// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"b4f43217","226":"c6bc8f76","245":"241b376b","446":"b5f45a4b","668":"5dcbf191","779":"7958a6d2","835":"7f7d0dca","950":"4c60a664","958":"51162eaa"}[chunkId] + ".chunk.js";
};